import { render, staticRenderFns } from "./branchallcountListForDateNew.vue?vue&type=template&id=0a991974&scoped=true"
import script from "./branchallcountListForDateNew.vue?vue&type=script&lang=js"
export * from "./branchallcountListForDateNew.vue?vue&type=script&lang=js"
import style0 from "./branchallcountListForDateNew.vue?vue&type=style&index=0&id=0a991974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a991974",
  null
  
)

export default component.exports